<template>
  <div id="adminProperties" class="cpl-aside-content hide-scrollbar right-side-menu">
    <!-- Invitet user dialog -->
    <div id="inviteUserForm" v-if="showUserForm">
      <custom-popup  @custom-popup-change="handleCustomPopupChange($event)" :isVisibleProp="true" class="common-gradient">
        <template #title>
          <div @click="handleCloseInviteUserForm" class="close-icon el-icon-close">
            <el-icon><Close /></el-icon>
          </div>
          <div class="title">{{ $t('label.inviteUser') }}</div>
        </template>
        <template #body>
          <el-form :model="userForm" :rules="userFormRules" ref="userForm" class="invite-user-form userForm auth-form">
            <!-- Email -->
            <el-form-item class="email f-item" prop="email">
              <el-input v-model.trim="userForm.email"
                :placeholder="$t('label.email')"
                @focus="fieldEventCommonStyle('focus', 'input-email', 'white')"
                @blur="fieldEventCommonStyle('blur', 'input-email', 'white')"
                class="cstm-input-white input-email">
              </el-input>
              <div v-if="error.length > 0" class="animated shake backend-error-msg target-el-form-item_email">{{error}}</div>
            </el-form-item>

            <!-- Firstname -->
            <el-form-item class="firstName f-item" prop="firstName">
              <el-input v-model="userForm.firstName"
              :placeholder="$t('label.firstName')"
              @focus="fieldEventCommonStyle('focus', 'input-firstName', 'white')"
              @blur="fieldEventCommonStyle('blur', 'input-firstName', 'white')"
              class="cstm-input-white input-firstName">
              </el-input>
              <div v-if="error.length > 0" class="animated shake backend-error-msg target-el-form-item_firstName">{{error}}</div>
            </el-form-item>

            <!-- Lastname -->
            <el-form-item class="lastName f-item" prop="lastName">
              <el-input v-model="userForm.lastName"
                :placeholder="$t('label.lastName')"
                @focus="fieldEventCommonStyle('focus', 'input-lastName', 'white')"
                @blur="fieldEventCommonStyle('blur', 'input-lastName', 'white')"
                class="cstm-input-white input-lastName">
              </el-input>
              <div v-if="error.length > 0" class="animated shake backend-error-msg target-el-form-item_lastName">{{error}}</div>
            </el-form-item>
          </el-form>

          <div class="error-message" v-if="showErrorOnTopOfDialog">
            {{dialogErrorMessage}}
          </div>
        </template>

        <template #footer>
          <el-button @click="handleUserFormSubmit" class="cstm-btn-white width-auto">{{$t('label.sendInvitation')}}</el-button>
        </template>
      </custom-popup>
    </div>
  </div>
</template>
<script src="./admin-user-invite.js"></script>
<style lang="scss" src="./admin-user-invite.scss"></style>
